module.exports = __webpack_public_path__ + "assets/img/netted-lines-2.svg";